import BaseUtil from "../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    initializing: true, // 初始化
    itemsVal: [], // 字段值
    customItemsVal: [], // 自定义字段值
    groups: null,
    groupEditable: null,
    fieldItems: null,
    allFieldItems: null,
    fileDetailGroup: null,
    fileDetailUser: null,

    editGroupKey: null, // 正在编辑的字段组的key
    editGroupRef: null, // 正在编辑的字段组的ref，scrollTo用
    groupInitializing: [],
    editLoading: false,
    submitLoading: false, // 提交loading

    canUpdate: false, // 待审批时是否可以点击编辑修改
    updateMode: false, // 待审批时点击修改后
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
};
export default viewModel;
